// globalFilterReducer.js

import { DEFAULT_TIME_RANGE } from "../utils/constants";
import { LOCAL_STORAGE_KEYS } from "../utils/localStorageUtil";
import { getRange } from "../utils/utility";

export const defaultState = {
  serialNumber: "",
  siteId: null,
  dateRange: getRange(DEFAULT_TIME_RANGE),
  isSerialNumberConfirmed: false,
};

const loadStateFromStorage = () => {
  if (typeof window === "undefined") return defaultState; // Safety for SSR

  try {
    const serializedState = localStorage.getItem(LOCAL_STORAGE_KEYS.GLOBAL_FILTERS);
    if (serializedState === null) {
      return defaultState; // No data found, use default
    }
    const state = JSON.parse(serializedState, (key, value) => {
      // Regex to detect ISO 8601 date strings (e.g., "2023-10-05T14:48:00.000Z")
      const datePattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/;

      if (typeof value === "string" && datePattern.test(value)) {
        return new Date(value);
      }
      return value;
    });

    return state;
  } catch (err) {
    console.warn("Error loading state from localStorage:", err);
    return defaultState; // Error parsing, safe fallback to default
  }
};

export const initialGlobalFilterState = loadStateFromStorage();

export default function globalFilterReducer(state, action) {
  let storedState;
  switch (action.type) {
    case "SET_GLOBAL_STATE":
      storedState = { ...state, ...action.payload };
      break;
    default:
      return state;
  }
  try {
    localStorage.setItem(LOCAL_STORAGE_KEYS.GLOBAL_FILTERS, JSON.stringify(storedState));
  } catch (err) {
    console.error("Error saving state to localStorage:", err);
  }
  return storedState;
}

export const setAppState = payload => ({
  type: "SET_GLOBAL_STATE",
  payload,
});
